export default __webpack_public_path__ + "static/support_teachers-6a93f341531b087754b095f5da850c58.mp4";